"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireDefault(require("../styled"));

var _classNames = require("../../utilities/classNames");

var _VisuallyHiddenCss = _interopRequireDefault(require("./styles/VisuallyHidden.css.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var VisuallyHidden = function VisuallyHidden(props) {
  var children = props.children,
      className = props.className,
      focusable = props.focusable,
      rest = _objectWithoutPropertiesLoose(props, ["children", "className", "focusable"]);

  var componentClassName = (0, _classNames.classNames)('c-VisuallyHidden', focusable && 'is-focusable', className);
  var tabIndex = focusable ? 1 : null;
  return _react.default.createElement("span", _extends({
    className: componentClassName,
    tabIndex: tabIndex
  }, rest), children);
};

VisuallyHidden.defaultProps = {
  focusable: false
};

var _default =
/*#__PURE__*/
(0, _styled.default)(VisuallyHidden, {
  target: "e385hzp0"
})(_VisuallyHiddenCss.default);

exports.default = _default;